import React from 'react'
import {Navigate,useLocation} from 'react-router-dom';
import _ from "lodash";

const ProtectedRoute = ({
    isAllowed,
    redirectPath = '/login',
    children,
}) => {

    const location = useLocation();
    //console.log("location:"+JSON.stringify(location));
    if (!isAllowed) {
        if (!_.isEmpty(location.pathname ) && location.pathname !== "/"){
            return <Navigate to={redirectPath+"?redirectTo="+location?.pathname} replace />;
        } else {
            return <Navigate to={redirectPath} replace />;
        }
    }
    return children ;
    //? children : <Outlet />;
};

export default ProtectedRoute